import Tag from '../models/Tag';
import { BASE_SCHEMA } from './baseConverters';
import { parseEntities, parseEntity } from './commonConverters';

export const TAG_SCHEMA = {
  ...BASE_SCHEMA,
  id: (data: any) => data.tagId ?? data.id,
  colorHex: 'colorHex',
  description: 'description',
  type: 'type',
  isPause: 'isPause',
};

const SCHEMA_EVENT_TAG = {
  description: 'label',
  colorHex: 'colorHex',
  type: 'type',
};

export function parseTag(data: any, overrides?: Partial<Tag>): Tag | null {
  const tag = parseEntity(data, TAG_SCHEMA, Tag);
  if (tag && overrides) Object.assign(tag, overrides);
  return tag;
}

export function parseTags(data: any, overrides?: Partial<Tag>): Array<Tag> {
  return parseEntities(data, d => parseTag(d, overrides));
}

export function parsePlannerEventTags(data: any): Array<Tag> {
  return parseEntities(data, SCHEMA_EVENT_TAG, Tag);
}
